import { createSlice } from '@reduxjs/toolkit';
export const callSessionsSlice = createSlice({
    name: 'callSessions',
    initialState: {
        maxActiveCalls: 2,
        activeCallCount: 0,
        sessions: [],
        activeCallId: null,
    },
    reducers: {
        setActiveCallCount: (state, action) => {
            state.activeCallCount = Number(action.payload);
        },
        setActiveCallId: (state, action) => {
            state.activeCallId = action.payload;
        },
        setCallSessions: (state, action) => {
            state.sessions = action.payload;
        },
        setSessionCrmContact: (state, action) => {
            const { sessionId, contact } = action.payload;
            const session = state.sessions.find(s => s.id === sessionId);
            if (session) {
                session.crmContact = contact;
            }
        },
        resetCallSessions: (state) => {
            state.maxActiveCalls = 2;
            state.activeCallCount = 0;
            state.sessions = [];
            state.activeCallId = null;
        },
    },
})
export const {
    setActiveCallCount,
    setActiveCallId,
    setCallSessions,
    setSessionCrmContact,
    resetCallSessions,
} = callSessionsSlice.actions;


export const selectMaxActiveCalls = (state) => state.callSessions.maxActiveCalls
export const selectActiveCallCount = (state) => state.callSessions.activeCallCount;
export const selectActiveCallId = (state) => state.callSessions.activeCallId;
export const selectActiveCall = (state) => {
    const activeCallId = selectActiveCallId(state);
    return state.callSessions.sessions.find(session => session.id === activeCallId) || null;
}
export const selectCallSessions = (state) => state.callSessions.sessions;


export default callSessionsSlice.reducer;